import { useLocation, useNavigate } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useGetPermissionDetailQuery } from "../../service/features/api";
import moment from "moment";


const RoleDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;

  const { data: roleDetail, isLoading } = useGetPermissionDetailQuery(id, { skip: !id });

  if (isLoading) return <div className="loading_state">Loading...</div>;

  const roleData = roleDetail?.data;
  const permissions = roleData?.permission || [];

  return (
    <>
      <CommonBreadcrumb
        title="Role Detail"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Manage Sub-Admin", onClick: () => navigate("/manage-subadmin") },
          { label: "Manage Roles", onClick: () => navigate("/manage-subadmin/roles") },
          { label: "Role Detail" },
        ]}
      />

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{roleData?.name || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{roleData?.createdAt ? moment(roleData.createdAt).format("DD MMMM YYYY") : "N/A"}</p>
          </div>
        </div>

        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Module Name</TableCell>
                <TableCell align="center">View</TableCell>
                <TableCell align="center">Add</TableCell>
                <TableCell align="center">Edit</TableCell>
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {permissions.map((row: any) => (
                <TableRow hover key={row._id}>
                  <TableCell>{row.label}</TableCell>
                  <TableCell align="center">
                    {row.isView ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                  <TableCell align="center">
                    {row.isAdd ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                  <TableCell align="center">
                    {row.isEdit ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                  <TableCell align="center">
                    {row.isDelete ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default RoleDetail;
